module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"cancel":"Abbrechen","newLearningDepartment":"Neue Abteilung","save":"Speichern","thereAreItemsThatRequireYourAttention":"Es gibt Felder, die Ihre Aufmerksamkeit erfordern."},"en":{"cancel":"Cancel","newLearningDepartment":"New department","save":"Save","thereAreItemsThatRequireYourAttention":"There are items that require your attention."}}')
  delete Component.options._Ctor
}
